export default __webpack_public_path__ + "locales/si/ChangePasswordDialog.json?hash=1a7eeb436e393a3a04814ad95c115943";